import createSvgIcon from '../create-svg-icon';

export const EastIcon = createSvgIcon(
  <path d="m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z" />
, 'EastOutlined');
